import { createFileRoute } from "@tanstack/react-router"
import DesignSystemButtonGroup from "~/pages/design-system/components/ButtonGroup"

export const Route = createFileRoute("/_auth/internal/design-system/components/button-group")({
  staticData: { skipSkuStoreData: true },
  component: RouteComponent,
})

function RouteComponent() {
  return <DesignSystemButtonGroup />
}
